import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CompanyRoleResolver } from "./company/shared/service/company-user-permissions.service";
import { InstallComponent } from "./pages/install/install.component";
import { NotFoundComponent } from "./pages/not-found/not-found.component";
import { RateLimitReachedComponent } from "./pages/rate-limit-reached/rate-limit-reached.component";
import { TestLandingPageComponent } from "./pages/test-landing-page/test-landing-page.component";
import { SelectivePreloadingStrategy } from "./shared/utils/preload-strategies";

const routes: Routes = [
	{ path: "rate-limit", component: RateLimitReachedComponent },
	{ path: "test-landing", component: TestLandingPageComponent },
	{ path: "install", component: InstallComponent },
	{
		path: "portal",
		loadChildren: () =>
			import("./portal/inductee/portal-inductee.module").then(
				(m) => m.PortalInducteeModule,
			),
		data: { preload: "medium" },
	},
	{
		path: "incident-reporting",
		loadChildren: () =>
			import("./incident-reporting/incident-reporting.module").then(
				(m) => m.IncidentReportingModule,
			),
		data: { preload: "low" },
	},
	{
		path: "sign-in-kiosk",
		loadChildren: () =>
			import("./sign-in-kiosk/sign-in-kiosk.module").then(
				(m) => m.SignInKioskModule,
			),
		data: { preload: "medium" },
	},
	{
		path: "company-web-portal",
		loadChildren: () =>
			import("./company-web-portal/company-web-portal.module").then(
				(m) => m.CompanyWebPortalModule,
			),
		data: { preload: "medium" },
	},
	{
		path: "contractor",
		loadChildren: () =>
			import("./portal/contractor/portal-contractor.module").then(
				(m) => m.PortalContractorModule,
			),
		data: { preload: "low" },
	},
	{
		path: "sign-in",
		loadChildren: () =>
			import("./portal/sign-in/portal-sign-in.module").then(
				(m) => m.PortalSignInModule,
			),
		data: { preload: "medium" },
	},
	{
		path: "website",
		loadChildren: () =>
			import("./website/website.module").then((m) => m.WebsiteModule),
		data: { preload: "high" },
	},
	{
		path: "invites",
		loadChildren: () => import("./invite/invite.module").then((m) => m.InviteModule),
		data: { preload: "medium" },
	},
	{
		path: "attempt",
		loadChildren: () =>
			import("./attempt/attempt.module").then((m) => m.AttemptModule),
		data: { preload: "high" },
	},
	{
		path: "referrer",
		loadChildren: () =>
			import("./referrer/referrer.module").then((m) => m.ReferrerModule),
		data: { preload: "low" },
	},
	{
		path: "induction-preview",
		loadChildren: () =>
			import("./induction-preview/induction-preview.module").then(
				(m) => m.InductionPreviewModule,
			),
		data: { preload: "low" },
	},
	{
		path: "",
		children: [
			{
				path: "",
				pathMatch: "full",
				redirectTo: "auth",
			},
			{
				path: "company",
				loadChildren: () =>
					import("./company/company.module").then((m) => m.CompanyModule),
				resolve: {
					permissions: CompanyRoleResolver,
				},
				data: { preload: "high" },
			},
			{
				path: "inductee",
				loadChildren: () =>
					import("./inductee/inductee.module").then((m) => m.InducteeModule),
				data: { preload: "medium" },
			},
			{
				path: "auth",
				loadChildren: () =>
					import("./auth/auth.module").then((m) => m.AuthModule),
				data: { preload: "high" },
			},
			{
				path: "oauth",
				loadChildren: () =>
					import("./oauth/oauth.module").then((m) => m.OauthModule),
				data: { preload: "low" },
			},

			{ path: "**", component: NotFoundComponent },
		],
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			useHash: true,
			paramsInheritanceStrategy: "always",
			preloadingStrategy: SelectivePreloadingStrategy,
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
